import React, { FC } from 'react';

import { Flex, IBoxProps, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import i18n from '../../utils/i18n';

type OverridePanelProps = Pick<IBoxProps, 'backgroundColor'> & {
  title: string;
  tooltipContent?: string;
  onResetClick: () => void;
  resetDataTestId?: string;
};

const OverridePanel: FC<OverridePanelProps> = ({
  title,
  tooltipContent,
  onResetClick,
  resetDataTestId,
}) => {
  return (
    <Flex
      display="inline-flex"
      height="32px"
      borderBottom={`1px solid ${theme.colors.charcoal200}`}
      padding="0 8px"
      minWidth={170}
      data-override-scope={title}
      data-override-url={tooltipContent}
    >
      <Tooltip
        content={tooltipContent}
        placement={Tooltip.PLACEMENTS.BOTTOM}
        renderTarget={(props) => (
          <Tooltip.Target {...props} shouldWrapChildren={false} />
        )}
      >
        <Flex alignItems="center" justifyContent="space-between" flex={1}>
          <Text typography="bodyMediumBold">{title}</Text>
          <LinkButton
            data-testid={resetDataTestId}
            style={{
              marginLeft: 8,
            }}
            onClick={onResetClick}
          >
            {i18n.t('RESET')}
          </LinkButton>
        </Flex>
      </Tooltip>
    </Flex>
  );
};

export default OverridePanel;
